(function() {
  'use strict';

  // ============================================
  // SETUP FEE VARIANT IDs TO EXCLUDE FROM COUNTING
  // ============================================
  const EXCLUDED_VARIANT_IDS = [
    45787698495676,  // Silk Screen Setup Fee
    45791285477564   // Embroidery Setup Fee
  ];

  const originalFetch = window.fetch;
  let lastValidation = 0;
  
  window.fetch = function(url, options) {
    const urlStr = url ? url.toString() : '';
    
    if ((urlStr.includes('checkout') || urlStr.includes('ymq.cool')) && window.cartMinimumNotMet) {
      console.log('BLOCKED checkout fetch:', urlStr);
      alert('⚠️ Minimum order not met! Please add more items.\n\nEmbroidery: Minimum 8 pieces\nSilk Screen: Minimum 25 pieces');
      throw new Error('Checkout blocked');
    }
    
    return originalFetch.apply(this, arguments);
  };

  // Helper function to check if an item is a setup fee
  function isSetupFee(item) {
    return EXCLUDED_VARIANT_IDS.includes(item.variant_id);
  }

  function validateCart(context) {
    const now = Date.now();
    if (now - lastValidation < 500) return;
    lastValidation = now;
    
    originalFetch('/cart.js')
      .then(function(r) { return r.json(); })
      .then(function(data) {
        let emb = 0, silk = 0;
        
        data.items.forEach(function(item) {
          // SKIP setup fee items - don't count them!
          if (isSetupFee(item)) {
            console.log('⏭️ Skipping setup fee from count:', item.title);
            return;
          }
          
          const dec = (item.properties && item.properties['Decoration Method']) || '';
          const decLower = dec.toLowerCase();
          if (decLower.includes('embroidery')) emb += item.quantity;
          if (decLower.includes('silk screen') || decLower.includes('silkscreen')) silk += item.quantity;
        });
        
        console.log('📊 Actual product counts (excluding fees) - Embroidery:', emb, '| Silk Screen:', silk);
        
        const errors = [];
        if (emb > 0 && emb < 8) errors.push('Embroidery: Need 8 (have ' + emb + '). Add ' + (8 - emb) + ' more.');
        if (silk > 0 && silk < 25) errors.push('Silk Screen: Need 25 (have ' + silk + '). Add ' + (25 - silk) + ' more.');
        
        window.cartMinimumNotMet = errors.length > 0;
        window.cartCounts = { embroidery: emb, silkScreen: silk };
        
        if (context === 'add-to-cart' || context === 'product-page') {
          showInlineProductMessage();
        } else if (context === 'cart-page') {
          updateCartPageMessage(errors);
        } else if (context === 'cart-drawer') {
          updateCartDrawerMessage(errors);
        }
        
        updateCheckoutButton();
      })
      .catch(function(err) {
        if (!err.message || !err.message.includes('Checkout blocked')) {
          console.error('Cart validation error:', err);
        }
      });
  }
  
  // OPTION 6 COMPACT DESIGN - Single line with progress bar
  function createCompactProgressBar(cartCount, minimum, type, pendingQty) {
    const total = cartCount + pendingQty;
    const percentage = Math.min(Math.round((total / minimum) * 100), 100);
    const isComplete = total >= minimum;
    
    const typeLabel = type === 'silk screen' ? 'silk screen' : 'embroidery';
    const remaining = minimum - total;
    
    if (isComplete) {
      // Success state - compact green banner
      return '<div style="' +
        'background: #f1f8f4;' +
        'border-left: 3px solid #4caf50;' +
        'padding: 8px 12px;' +
        'margin: 10px 0;' +
        'border-radius: 4px;' +
        'font-size: 12px;' +
        'color: #2e7d32;' +
        'line-height: 1.5;' +
      '">' +
        '<strong style="font-size: 13px;">✓ Minimum met:</strong> ' +
        '<span style="opacity: 0.9;">' + total + ' of ' + minimum + ' for ' + typeLabel + '</span>' +
      '</div>';
    } else {
      // Warning state - compact pink banner with mini progress
      return '<div style="' +
        'background: #fff5f5;' +
        'border-left: 3px solid #f44336;' +
        'padding: 8px 12px;' +
        'margin: 10px 0;' +
        'border-radius: 4px;' +
        'font-size: 12px;' +
        'color: #c62828;' +
        'line-height: 1.5;' +
      '">' +
        '<strong style="font-size: 13px;">⚠️ Minimum:</strong> ' +
        '<span style="opacity: 0.9;">Need ' + minimum + ' pcs (' + remaining + ' more to go)</span>' +
        '<div style="' +
          'background: #ffebee;' +
          'height: 4px;' +
          'border-radius: 2px;' +
          'margin: 6px 0 4px;' +
          'overflow: hidden;' +
        '">' +
          '<div style="' +
            'background: #f44336;' +
            'height: 100%;' +
            'width: ' + percentage + '%;' +
            'min-width: ' + (percentage > 0 ? '4px' : '0') + ';' +
          '"></div>' +
        '</div>' +
        '<span style="opacity: 0.75; font-size: 11px;">' + total + ' of ' + minimum + '</span>' +
      '</div>';
    }
  }
  
  function showInlineProductMessage() {
    const counts = window.cartCounts || { embroidery: 0, silkScreen: 0 };
    
    const qtyInput = document.querySelector('.quantity__input, input[name="quantity"]');
    const pendingQty = qtyInput ? parseInt(qtyInput.value) || 1 : 1;
    
    const embSelected = isEmbroiderySelected();
    const silkSelected = isSilkScreenSelected();
    
    const existing = document.getElementById('min-order-inline-msg');
    if (existing) existing.remove();
    
    let html = '';
    
    // Show bar when decoration method is selected (even if cart is empty)
    if (embSelected) {
      html = createCompactProgressBar(counts.embroidery, 8, 'embroidery', pendingQty);
    } else if (silkSelected) {
      html = createCompactProgressBar(counts.silkScreen, 25, 'silk screen', pendingQty);
    }
    
    if (!html) return;
    
    const container = document.createElement('div');
    container.id = 'min-order-inline-msg';
    container.innerHTML = html;
    
    const qtySection = document.querySelector('.product-form__quantity');
    if (qtySection) {
      qtySection.parentNode.insertBefore(container, qtySection.nextSibling);
    }
  }
  
  function isEmbroiderySelected() {
    const checkedInputs = document.querySelectorAll('.ymq-options-box:not(.ymq-option-condition-hide) input:checked');
    let found = false;
    
    checkedInputs.forEach(function(input) {
      if (input.value && input.value.toLowerCase().includes('embroidery')) {
        found = true;
      }
    });
    
    const visibleEmbOptions = document.querySelectorAll('.ymq-options-box:not(.ymq-option-condition-hide)');
    visibleEmbOptions.forEach(function(box) {
      const label = box.querySelector('.ymq_lable');
      if (label) {
        const text = label.textContent.toLowerCase();
        if (text.includes('embroidery file setup') || text.includes('logo placement')) {
          found = true;
        }
      }
    });
    
    return found;
  }
  
  function isSilkScreenSelected() {
    const checkedInputs = document.querySelectorAll('.ymq-options-box:not(.ymq-option-condition-hide) input:checked');
    let found = false;
    
    checkedInputs.forEach(function(input) {
      if (input.value && input.value.toLowerCase().includes('silk screen')) {
        found = true;
      }
    });
    
    const visibleOptions = document.querySelectorAll('.ymq-options-box:not(.ymq-option-condition-hide)');
    visibleOptions.forEach(function(box) {
      const label = box.querySelector('.ymq_lable');
      if (label) {
        const text = label.textContent.toLowerCase();
        if (text.includes('ink color') || text.includes('print sides') || text.includes('screen setup')) {
          found = true;
        }
      }
    });
    
    return found;
  }
  
  function setupQuantityWatcher() {
    const qtyInput = document.querySelector('.quantity__input, input[name="quantity"]');
    if (qtyInput && !qtyInput.dataset.watcherAdded) {
      qtyInput.dataset.watcherAdded = 'true';
      
      qtyInput.addEventListener('change', showInlineProductMessage);
      qtyInput.addEventListener('input', showInlineProductMessage);
    }
    
    document.addEventListener('click', function(e) {
      if (e.target.closest('.quantity__button, [name="plus"], [name="minus"]')) {
        setTimeout(showInlineProductMessage, 50);
      }
      
      if (e.target.closest('.ymq-options-box, .ymq-app-select-option')) {
        setTimeout(showInlineProductMessage, 150);
      }
    });
    
    const ymqContainer = document.querySelector('[class*="ymq"]');
    if (ymqContainer) {
      const observer = new MutationObserver(function() {
        setTimeout(showInlineProductMessage, 100);
      });
      
      observer.observe(ymqContainer, {
        attributes: true,
        childList: true,
        subtree: true
      });
    }
  }
  
  function updateCartDrawerMessage(errors) {
    const old = document.getElementById('min-order-drawer-msg');
    
    if (errors.length === 0) {
      if (old) old.remove();
      return;
    }
    
    // OPTION 6 COMPACT DESIGN for cart drawer
    const compactMessage = '<div style="' +
      'background: #fff5f5;' +
      'border-left: 3px solid #f44336;' +
      'padding: 10px 14px;' +
      'border-radius: 6px;' +
      'font-size: 12px;' +
      'color: #c62828;' +
      'line-height: 1.5;' +
    '">' +
      '<strong style="font-size: 13px;">⚠️ Minimum not met</strong><br>' +
      '<span style="opacity: 0.9; font-size: 11px;">' + errors.join(' • ') + '</span>' +
    '</div>';
    
    if (old) {
      old.innerHTML = compactMessage;
      return;
    }
    
    const drawerContent = document.querySelector('#cart-notification .drawer__inner, #cart-notification .cart-notification__content, #cart-notification [role="dialog"]');
    if (!drawerContent) return;
    
    const errorDiv = document.createElement('div');
    errorDiv.id = 'min-order-drawer-msg';
    errorDiv.style.cssText = 'margin: 15px;';
    errorDiv.innerHTML = compactMessage;
    
    drawerContent.insertBefore(errorDiv, drawerContent.firstChild);
  }
  
  function updateCartPageMessage(errors) {
    const old = document.getElementById('min-order-cart-msg');
    
    if (errors.length === 0) {
      if (old) old.remove();
      return;
    }
    
    // OPTION 6 COMPACT DESIGN for cart page
    const compactMessage = '<div style="' +
      'background: #fff5f5;' +
      'border-left: 3px solid #f44336;' +
      'padding: 10px 14px;' +
      'border-radius: 6px;' +
      'font-size: 12px;' +
      'color: #c62828;' +
      'line-height: 1.5;' +
    '">' +
      '<strong style="font-size: 13px;">⚠️ Minimum Order Not Met</strong> ' +
      '<span style="opacity: 0.9;">' + errors.join(' • ') + '</span>' +
      '<em style="opacity: 0.7; font-size: 11px; margin-left: 6px;">Mix sizes to reach minimum</em>' +
    '</div>';
    
    if (old) {
      old.innerHTML = compactMessage;
      return;
    }
    
    const totalsSection = document.querySelector('.cart__footer') || 
                          document.querySelector('.cart-footer') ||
                          document.querySelector('[class*="totals"]');

    const cartForm = document.getElementById('cart') || 
                     document.querySelector('#MainContent form[action="/cart"]');

    if (!cartForm) return;

    const errorDiv = document.createElement('div');
    errorDiv.id = 'min-order-cart-msg';
    errorDiv.style.cssText = 'margin: 20px 0;';
    errorDiv.innerHTML = compactMessage;

    if (totalsSection) {
      totalsSection.parentNode.insertBefore(errorDiv, totalsSection);
    } else {
      cartForm.appendChild(errorDiv);
    }
  }

  function updateCheckoutButton() {
    const checkoutBtns = document.querySelectorAll('button[name="checkout"], a[href*="/checkout"], #CartDrawer-Checkout, .cart__checkout-button, [href="/checkout"]');
    
    checkoutBtns.forEach(function(btn) {
      if (window.cartMinimumNotMet) {
        btn.style.setProperty('display', 'none', 'important');
      } else {
        btn.style.removeProperty('display');
      }
    });
  }

  let justAddedToCart = false;
  
  document.addEventListener('click', function(e) {
    const addButton = e.target.closest('[data-add-to-cart], .add-to-cart, button[name="add"], .product-form__submit, .shopify-payment-button__button');
    if (addButton) {
      justAddedToCart = true;
      setTimeout(function() {
        validateCart('add-to-cart');
        setTimeout(function() {
          justAddedToCart = false;
        }, 3000);
      }, 1500);
    }
  });
  
  const observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
        const cartDrawer = document.querySelector('#cart-notification');
        if (cartDrawer && cartDrawer.classList.contains('active')) {
          if (!justAddedToCart) {
            validateCart('cart-drawer');
          }
        }
      }
    });
  });
  
  const cartNotification = document.querySelector('#cart-notification');
  if (cartNotification) {
    observer.observe(cartNotification, { attributes: true });
  }

  if (window.location.pathname === '/cart') {
    setTimeout(function() { 
      validateCart('cart-page'); 
    }, 500);
    
    document.addEventListener('change', function(e) {
      if (e.target.matches('input[name="updates[]"], input[type="number"]')) {
        setTimeout(function() { validateCart('cart-page'); }, 1000);
      }
    });
    
    document.addEventListener('click', function(e) {
      if (e.target.closest('[href*="/cart/change"], .cart__remove, [data-cart-remove]')) {
        setTimeout(function() { validateCart('cart-page'); }, 1000);
      }
    });
  }
  
  if (window.location.pathname.includes('/products/')) {
    // Initialize cart counts first
    window.cartCounts = { embroidery: 0, silkScreen: 0 };
    
    // Fetch cart and then show message
    originalFetch('/cart.js')
      .then(function(r) { return r.json(); })
      .then(function(data) {
        let emb = 0, silk = 0;
        data.items.forEach(function(item) {
          // SKIP setup fee items - don't count them!
          if (isSetupFee(item)) {
            console.log('⏭️ Skipping setup fee from initial count:', item.title);
            return;
          }
          
          const dec = (item.properties && item.properties['Decoration Method']) || '';
          const decLower = dec.toLowerCase();
          if (decLower.includes('embroidery')) emb += item.quantity;
          if (decLower.includes('silk screen') || decLower.includes('silkscreen')) silk += item.quantity;
        });
        window.cartCounts = { embroidery: emb, silkScreen: silk };
        window.cartMinimumNotMet = (emb > 0 && emb < 8) || (silk > 0 && silk < 25);
        
        console.log('📊 Initial counts (excluding fees) - Embroidery:', emb, '| Silk Screen:', silk);
        
        setupQuantityWatcher();
        showInlineProductMessage();
      });
  }
  
  setTimeout(function() {
    originalFetch('/cart.js')
      .then(function(r) { return r.json(); })
      .then(function(data) {
        let emb = 0, silk = 0;
        data.items.forEach(function(item) {
          // SKIP setup fee items - don't count them!
          if (isSetupFee(item)) return;
          
          const dec = (item.properties && item.properties['Decoration Method']) || '';
          const decLower = dec.toLowerCase();
          if (decLower.includes('embroidery')) emb += item.quantity;
          if (decLower.includes('silk screen') || decLower.includes('silkscreen')) silk += item.quantity;
        });
        window.cartMinimumNotMet = (emb > 0 && emb < 8) || (silk > 0 && silk < 25);
        window.cartCounts = { embroidery: emb, silkScreen: silk };
        updateCheckoutButton();
      });
  }, 300);
  
  document.addEventListener('cart:updated', function() {
    if (window.location.pathname === '/cart') {
      validateCart('cart-page');
    } else if (window.location.pathname.includes('/products/')) {
      validateCart('product-page');
    } else {
      validateCart('cart-drawer');
    }
  });

})();